// Shared scaffold for the public static/legal pages (privacy policy, delete-account
// guide, contact, landing) rehosted from the retired legacy frontend. These pages
// keep their exact public hash URLs so external references (app-store listings, the
// mobile app, emails) continue to resolve after the old frontend is removed.
import type { ReactNode } from 'react'
import BrandLockup from '../../components/BrandLockup'

type StaticPageLayoutProps = {
  title: string
  /** When true, use the wide reading layout for long prose (legal pages). */
  wide?: boolean
  children: ReactNode
}

const StaticPageLayout = ({ title, wide = false, children }: StaticPageLayoutProps) => {
  return (
    <div className="cf-page">
      <div className={`cf-card ${wide ? 'cf-content-card' : ''}`}>
        <BrandLockup />
        <h1 className="cf-title">{title}</h1>
        {children}
      </div>
    </div>
  )
}

export default StaticPageLayout
